import React from "react"
import { Stack, HStack, Container } from "@chakra-ui/react"

import CalloutTile from "@components/CalloutTile/CalloutTile"
import { useRoutes } from "@hooks/useRoutes"
import { useImage } from "@hooks/useImage"

export interface CalloutCampaignRowProps {
  callout?: GatsbyTypes.SanityCallout
  images?: GatsbyTypes.SanityCustomImage[]
  toggle?: "On" | "Off"
}

const CalloutCampaignRow = ({ callout, images, toggle }: CalloutCampaignRowProps) => {
  const { urlResolver } = useRoutes()
  const { getGatsbyImage } = useImage()
  const campaignImages = images?.map(getGatsbyImage) || []

  const item: NormalisedCallout = {
    key: callout?._key,
    image: getGatsbyImage(callout?.image),
    link: urlResolver(callout?.link),
  }

  const content = (
    <>
      <Stack display={["flex", "none"]} spacing={2.5} py={4.5}>
        <CalloutTile key={item?.key} image={item?.image} link={item?.link} size="large" />
        <HStack spacing={2} justifyContent="center" alignItems="center">
          {campaignImages.map(image => (
            <CalloutTile key={image.key} image={image} size="small" toggle={toggle} />
          ))}
        </HStack>
      </Stack>
      <HStack display={["none", "flex"]} spacing={2} py={4.5} justifyContent="center" alignItems="center">
        <CalloutTile key={item?.key} image={item?.image} link={item?.link} size="medium" />
        {campaignImages.map(image => (
          <CalloutTile key={image.key} image={image} size="medium" toggle={toggle} />
        ))}
      </HStack>
    </>
  )

  return <Container>{content}</Container>
}

export default React.memo(CalloutCampaignRow)
